// Pick a customer from the Customers list -- never typed. Records link to a
// customer by name, and the server refuses names that aren't in the list
// (backend/customers.py), so every customer stays one record with one
// history. Options are fetched once and shared by every picker on the page.
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SearchableSelect } from "@/components/ui/searchable-select";

const NONE = "__no_customer__";
let cache = null;
export const loadCustomers = () => {
  if (!cache) {
    cache = api.get("/customers/", { params: { limit: 5000 } })
      .then(({ data }) => (data.items || []).map((c) => c.name).filter(Boolean).sort((a, b) => a.localeCompare(b)))
      .catch((e) => { cache = null; throw e; });
  }
  return cache;
};
export const clearCustomerCache = () => { cache = null; };

export default function CustomerSelect({ value, onChange, disabled, optional = true, testId }) {
  const [names, setNames] = useState([]);
  useEffect(() => { loadCustomers().then(setNames).catch(() => setNames([])); }, []);
  // An older record may name a customer that isn't in the list: still show it.
  const all = value && !names.includes(value) ? [value, ...names] : names;
  const options = [
    ...(optional ? [{ value: NONE, label: "No customer" }] : []),
    ...all.map((n) => ({ value: n, label: n })),
  ];
  return (
    <SearchableSelect value={value || ""} disabled={disabled} testId={testId} placeholder="Search customers…"
      options={options} onValueChange={(v) => onChange(v === NONE ? "" : v)} />
  );
}
